<div class="fullscreen-container">
    <div class="close-button" (click)="onClose()">
        <span class="iconify" data-icon="mdi:close" data-inline="false" data-width="34" data-height="34"
            style="color:white"></span>
    </div>
    <ngb-carousel [interval]="false" #carousel [showNavigationArrows]="imagesLoaded.length > 1">
        <ng-template ngbSlide *ngFor="let image of imagesLoaded; let i = index" id="{{i}}">
            <div class="picsum-img-wrapper">
                <div class="div-img-carousel" id="img-container">
                    <img  [src]="image.path" class="img-carousel hidden no-clickable" id="{{'img-element'+i}}">
                </div>
            </div>
            <div class="carousel-caption">
                <h4>{{image.title}}</h4>
                <p>{{image.description}}</p>
            </div>
        </ng-template>
    </ngb-carousel>
</div>
